var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanericon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48221 1.43043C9.32126 1.09637 8.98113 0.883789 8.60759 0.883789C8.23406 0.883789 7.89696 1.09637 7.73297 1.43043L5.78026 5.44822L1.4193 6.09204C1.05487 6.1467 0.751185 6.4018 0.63882 6.75104C0.526456 7.10028 0.617562 7.48596 0.878733 7.7441L4.04316 10.8751L3.29609 15.2999C3.23535 15.6643 3.3872 16.0348 3.68785 16.2504C3.9885 16.466 4.38633 16.4933 4.71431 16.3202L8.61063 14.24L12.5069 16.3202C12.8349 16.4933 13.2328 16.4691 13.5334 16.2504C13.8341 16.0317 13.9859 15.6643 13.9252 15.2999L13.1751 10.8751L16.3395 7.7441C16.6007 7.48596 16.6948 7.10028 16.5794 6.75104C16.464 6.4018 16.1633 6.1467 15.7989 6.09204L11.4349 5.44822L9.48221 1.43043Z",
    fill: "#EAB308"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanericon3);
export default __webpack_public_path__ + "static/media/banericon3.221c30763dd8d6dacbe897439b32a840.svg";
export { ForwardRef as ReactComponent };